var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBaccarat = function SvgBaccarat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sidebar (games+)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Intersect",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9995 40.6492C33.5534 40.8607 33.0942 41.0496 32.6231 41.2144C30.378 42 27.5853 42 21.9997 42C16.4142 42 13.6214 42 11.3763 41.2144C10.9053 41.0496 10.446 40.8607 10 40.6492V29C10 24.5817 13.5816 21 17.9998 21H25.9996C30.4178 21 33.9995 24.5817 33.9995 29V40.6492Z",
    fill: "#39B603"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9999 2C16.0725 2.00279 13.4832 2.04814 11.3762 2.78538C7.35461 4.19253 4.19271 7.35443 2.78557 11.376C2 13.6211 2 16.414 2 21.9998C2 27.5856 2 30.3786 2.78557 32.6237C4.19271 36.6452 7.35461 39.8071 11.3762 41.2142C13.4832 41.9515 16.0725 41.9968 20.9999 41.9996V41.9993C16.0737 41.9965 13.4847 41.9511 11.3779 41.2139C10.166 40.7898 9.0321 40.2064 8.0008 39.4881V28.0661C8.0008 23.0588 12.1794 18.9995 17.3339 18.9995H20.9999V2Z",
    fill: "#00BAD9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0005 41.9998C27.5176 41.9973 30.0697 41.9589 32.0867 41.3845C30.0697 41.9586 27.5174 41.9969 23.0005 41.9995V41.9998ZM23.0005 18.9996H26.6675C31.822 18.9996 36.0006 23.0589 36.0006 28.0663V39.489C38.3917 37.8238 40.2314 35.4336 41.2146 32.6238C42.0002 30.3787 42.0002 27.5858 42.0002 22C42.0002 16.4142 42.0002 13.6213 41.2146 11.3762C39.8074 7.35461 36.6455 4.19271 32.624 2.78557C30.517 2.04834 27.9277 2.00297 23.0005 2.00018V18.9996Z",
    fill: "#F05129"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBaccarat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/baccarat.837428ae.svg";
export { ForwardRef as ReactComponent };